import React from "react";
import "./wishlistCard.scss";
import { Button, Skeleton } from "@mui/material";
import { Link } from "react-router-dom";

const WishlistCardSkeleton = () => {
  return (
    <div className="wishlist-card">
      <div className="single-wishlist-card">
        <Link>
          <div className="product-img-container">
            <Skeleton
              animation="wave"
              variant="rectangular"
              component="img"
              className="product-img"
            />
          </div>
          <div className="basic-details">
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Skeleton animation="wave">
                <div className="product-name">product-name</div>
              </Skeleton>
            </div>

            <div className="price-container">
              <Skeleton animation="wave">
                <div>₹2520</div>
              </Skeleton>
            </div>
          </div>
        </Link>
        <div className="btn-container">
          <Button className="btn" disabled>
            Remove
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WishlistCardSkeleton;
